export default async function getClientTokenResetPassword(data: string): Promise<void> {
  try {
    const url = `/customer-identity/single-sign-on/session/reset-password?data=${encodeURIComponent(
      data,
    )}`
    await fetch(url)
  } catch (error) {
    console.error(error)
  }
}
